export default __webpack_public_path__ + "static/icon-tile-light-dd440494eed16386c13b1316225617c7f23a64c65bcc5733e4ccdf57fb7df14b.png";